import ThreeInstance from 'src/sdk-components/ThreeInstance';
//import { acceleratedRaycast, computeBoundsTree, disposeBoundsTree, MeshBVH } from 'three-mesh-bvh';

/**
 * The CachedGeometry class defines unique singleton Geometry instance.
 */
export class CachedGeometry {
  private static instance: CachedGeometry;

  private static cBoxGeometry: THREE.BufferGeometry;

  private static cSphereGeometry: THREE.BufferGeometry;

  public static THREE: any;

  private constructor() {
    Promise.resolve(ThreeInstance.get()).then((v) => {
      console.log('Init CachedGeometry');
      CachedGeometry.THREE = v;
      CachedGeometry.cBoxGeometry = new CachedGeometry.THREE.BoxBufferGeometry();
      CachedGeometry.cSphereGeometry = new CachedGeometry.THREE.SphereBufferGeometry();
      CachedGeometry.InitBVH();
    });
  }

  private static InitBVH() {
    // CachedGeometry.THREE.Mesh.prototype.raycast = acceleratedRaycast;
    // CachedGeometry.THREE.BufferGeometry.prototype.computeBoundsTree = computeBoundsTree;
    // CachedGeometry.THREE.BufferGeometry.prototype.disposeBoundsTree = disposeBoundsTree;
  }

  public static TempInit() {
    // TODO :Remove, to use on site
    if (!CachedGeometry.instance) CachedGeometry.instance = new CachedGeometry();
  }

  public static CreateBVHProxy(geometry: THREE.BufferGeometry) {
    if (!CachedGeometry.instance) CachedGeometry.instance = new CachedGeometry();
    if (0) geometry;
    //geometry.boundsTree = new MeshBVH( geometry );
  }

  public static BoxGeometry(): THREE.BufferGeometry {
    if (!CachedGeometry.instance) CachedGeometry.instance = new CachedGeometry();
    return CachedGeometry.cBoxGeometry;
  }

  public static SphereGeometry(): THREE.BufferGeometry {
    if (!CachedGeometry.instance) CachedGeometry.instance = new CachedGeometry();
    return CachedGeometry.cSphereGeometry;
  }

  public static CreateBufferGeometry(geo: any): THREE.BufferGeometry {
    if (!CachedGeometry.instance) CachedGeometry.instance = new CachedGeometry();
    return new CachedGeometry.THREE.BufferGeometry().setFromPoints(geo);
  }

  public static CreateBoundingBox(geo: THREE.BufferGeometry): THREE.Box3 | null {
    if (!CachedGeometry.instance) CachedGeometry.instance = new CachedGeometry();
    geo.computeBoundingBox();
    return geo.boundingBox;
  }

  public static CreateColliderMeshBoundingBoxFromScene(three, geo: THREE.Scene): THREE.Object3D {
    // if (!CachedGeometry.instance) CachedGeometry.instance = new CachedGeometry();
    try {
      const b = new three.Box3();
      b.setFromObject(geo);
      // make a BoxBufferGeometry of the same size as Box3
      const dimensions = new three.Vector3();
      dimensions.subVectors(b.max, b.min);
      const boxGeo = new three.BoxBufferGeometry(dimensions.x, dimensions.y, dimensions.z);
      return boxGeo;
      //  return new CachedGeometry.THREE.Mesh(boxGeo,new CachedGeometry.THREE.MeshBasicMaterial());
    } catch (e) {
      console.log('[Err] Collider computing in ', geo, e);
      const geometry = new three.THREE.BufferGeometry();
      const points = [
        three.THREE.Vector3(-1, 1, -1), //c
        three.THREE.Vector3(-1, -1, 1), //b
        three.THREE.Vector3(1, 1, 1), //a

        three.THREE.Vector3(1, 1, 1), //a
        three.THREE.Vector3(1, -1, -1), //d
        three.THREE.Vector3(-1, 1, -1), //c

        three.THREE.Vector3(-1, -1, 1), //b
        three.THREE.Vector3(1, -1, -1), //d
        three.THREE.Vector3(1, 1, 1), //a

        three.THREE.Vector3(-1, 1, -1), //c
        three.THREE.Vector3(1, -1, -1), //d
        three.THREE.Vector3(-1, -1, 1), //b
      ];

      geometry.setFromPoints(points);
      geometry.computeVertexNormals();
      return geometry;
    }
  }
}
